module.exports = __webpack_public_path__ + "static/media/fondes.f1987c4c.png";